import { Rutas } from '@/constants/rutas';
import AlineacionesProbablesIcon from '@/components/shared/icons/alineaciones-probables-icon';
import CalendarioFantasyAdminIcon from '../../icons/calendario-fantasy-admin';
import { LOTTIE_ICONS } from '@/DesignSystem/features/lottie/lottie-icons';

export const NavigationLaLigaItems = [
    {
        title: 'Calendario',
        shortTitle: 'Calendario',
        path: Rutas.CALENDARIO_FANTASY,
        id: 'calendario',
        icon: <CalendarioFantasyAdminIcon iconWidth={20} />,
    },
    {
        title: 'Tarjetas amarillas',
        shortTitle: 'Amarillas',
        path: Rutas.SALDO_ARBITRAL_PARTIDOS,
        id: 'tarjetas-amarillas',
    },
    {
        title: 'Tarjetas rojas',
        shortTitle: 'Rojas',
        path: Rutas.SALDO_ARBITRAL_PARTIDOS_ROJAS,
        id: 'tarjetas-rojas',
    },
    {
        title: 'FIFA',
        shortTitle: 'FIFA',
        path: Rutas.VIRUS_FIFA,
        id: 'fifa',
    },
    {
        title: 'Clasificación',
        shortTitle: 'Clasificación',
        path: `${Rutas.CLASIFICACION}`,
        id: 'clasificacion',
    },
    {
        title: 'Alineaciones Probables',
        shortTitle: 'Onces',
        path: `${Rutas.ALINEACIONES_PROBABLES}`,
        id: 'alineaciones-probables',
        icon: (
            <AlineacionesProbablesIcon iconWidth={20} color="#ccc" style={{ transform: 'rotate(90deg)' }} />
        ),
    },
    {
        title: 'Fichajes',
        shortTitle: 'Fichajes',
        path: `${Rutas.FICHAJES}`,
        id: 'fichajes',
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <path
                    fill="none"
                    stroke="green"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M7 10h14l-4-4"
                />
                <path
                    fill="none"
                    stroke="red"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17 16H3l4 4"
                />
            </svg>
        ),
    },
];
